export default __webpack_public_path__ + "static/media/GRATULACJE_DRUZYNO.ceebbb26.png";